import { z } from 'zod';

export const AuditLeadRequestDto = z.object({
  f_name: z.string().default('').optional(),
  l_name: z.string().default('').optional(),
  email: z.string().default('').optional(),
  phone1: z.string().regex(/\d*/).default('').optional(),
  address1: z.string().default('').optional(),
  city: z.string().default('').optional(),
  state: z.string().default('').optional(),
  zip: z
    .string()
    .regex(/\d{0,5}/)
    .default('')
    .optional(),
  tcpa_universal_id: z.string().default('').optional(),
  dob: z.string().default('').optional(),
  gender: z.enum(['m', 'f', '']).default('').optional(),
  smoker: z.enum(['y', 'n', '']).default('').optional(),
});

export type AuditLeadRequestDto = z.infer<typeof AuditLeadRequestDto>;

export const AuditLeadResponseDto = z.object({
  status: z.number(),
  data: z.string(),
  error: z.unknown().nullable().optional(),
});

export type AuditLeadResponseDto = z.infer<typeof AuditLeadResponseDto>;

export const AuditLeadHeadersDto = z.object({
  'snowplow-data': z.string().optional().default(''),
});

export type AuditLeadHeadersDto = z.infer<typeof AuditLeadHeadersDto>;
